import formatName from "../../helpers/formatName";
import { Grid } from "@mui/material";

function FuncionarioEmpresa({ data, plano }) {
  return (
    <div style={{ width: "100%" }}>
      <div style={{ marginTop: 15 }}>
        <h3
          style={{
            fontWeight: "700",
            fontSize: 20,
            margin: 0,
            marginTop: 20,
            color: "#191919",
          }}
        >
          Olá, {formatName(data.nome)}
        </h3>
        <h4
          style={{
            fontWeight: "400",
            fontSize: 16,
            margin: 0,
            color: "#191919",
          }}
        >
          Sua assinatura faz parte de um plano empresarial
        </h4>
        <Grid container spacing={2}>
          <Grid item sm={5} xs={12}>
            <div style={{ marginTop: 30 }}>
              <div style={styles.containerList}>
                <span
                  style={{
                    fontWeight: "700",
                    fontSize: 14,
                    color: "#398A94",
                    background: "#F2F7FA",
                    borderRadius: 7,
                  }}
                >
                  Abaixo os detalhes referente ao seu plano
                </span>{" "}
                <div style={styles.listaDetalhes}>
                  Plano - {formatName(plano.nome)}
                </div>
                <div style={styles.listaDetalhes}>
                  Contratante - {formatName(data.empresa.razaoSocial)}
                </div>
                <div style={styles.listaDetalhes}>
                  Permite dependentes -{" "}
                  {plano.permitirDependentes ? "Sim" : "Não"}
                </div>
                <div style={styles.listaDetalhes}>
                  Máximo de dependentes -{" "}
                  {plano.maximoDependentes ? plano.maximoDependentes : 0}
                </div>
                <div style={styles.listaDetalhes}>
                  Possui telemedicina - {plano.telemedicina ? "Sim" : "Não"}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>

        <div style={{ paddingBottom: 30, fontSize: 14 }}>
          Dúvidas, entre em contato com o administrador do seu plano{" "}
          <b>{data?.empresa?.email}</b> ou <b>{data?.empresa?.telefone}</b>{" "}
        </div>
      </div>
    </div>
  );
}

const styles = {
  listaDetalhes: {
    background: "#F8F8F8",
    margin: "10px 0px",
    width: "100%",
    fontSize: 14,
    fontWeight: "400",
  },
  containerList: {
    border: "1px solid #141414",
    padding: 10,
    borderRight: "4px solid #141414",
    borderBottom: "4px solid #141414",
    borderRadius: 10,
    marginBottom: 30,
  },
};

export default FuncionarioEmpresa;
